export function escapeSpecialRegexChars(str = '') {
  const chars = [
    "[", "\\", "^", "$",  ".",  "|",  "?",  "*",  "+",  "(", ")",
  ];

  return str.split('').map(
    o => chars.includes(o) ? `\\${o}` : o
  ).join('');
}
